<template>
  <div id="commercial-service-booking-detail-history-page">
    <v-container fluid class="px-0 d-flex" style="min-height: 400px;">
      <template>
        <v-row align="center">
          <v-spacer />
          <v-col cols="12" md="6">
            <v-timeline :key="index" v-for="(data, index) in histories" align-top dense>
              <v-timeline-item :color="getColor(data.statusCode)">
                <v-row class="pt-1">
                  <v-col cols="5" style="padding-top: 1.1rem">
                    <strong class="text-datetime">{{ getDisplayTime(data.createdAt) }}</strong>
                  </v-col>
                  <v-col cols="7">
                    <strong class="text-content-title">{{ data.statusName }}</strong>
                    <div v-if="data.rejectReason" class="text-content-detail">เหตุผลการยกเลิก : {{ data.rejectReason }}</div>
                    <div class="text-content-detail">{{ data.createdBy }}</div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-col>
          <v-spacer />
        </v-row>
      </template>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { BookingStatuses } from '@/common/api/config';

export default {
  computed: {
    ...mapGetters(['mailboxReport', 'mailboxAgingMaximum']),
  },
  props: {
    data: {
      type: Object,
    },
    histories: {
      type: Array,
    },
  },
  data() {
    return {
    };
  },
  created() {
    // console.log('created data', this.data);
  },
  methods: {
    getDisplayTime(dateTime) {
      return moment.utc(dateTime).local().locale('th').format('DD MMM YYYY, HH:mm น.') || '-';
    },
    getColor(statusCode) {
      // console.log('BookingStatuses', BookingStatuses);
      // console.log('data', data);
      const colorCode = BookingStatuses.find(v => v.code === statusCode).color;
      return colorCode || null;
    },
  },
};
</script>
<style lang="scss" scope>
#commercial-service-booking-detail-history-page {
  .text-datetime {
    color: black;
  }
  .text-content-title {
    color: black;
  }
  .text-content-detail {
    color: black;
  }
}
</style>

